/** Joins Tailwind class strings, dropping falsy branches from conditionals. */
export function cn(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ');
}
